import { useEffect } from "react";
import { useTheme } from "next-themes";

const FaviconManager = () => {
  const { theme, systemTheme } = useTheme();

  useEffect(() => {
    const updateFavicon = () => {
      const currentTheme = theme === "system" ? systemTheme : theme;
      const isDark = currentTheme === "dark";
      const faviconPath = isDark ? "/favlogo-dark.png" : "/favlogo-light.png";

      // Update standard favicon
      const link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.setAttribute("href", faviconPath);
      } else {
        const newLink = document.createElement("link");
        newLink.rel = "icon";
        newLink.href = faviconPath;
        document.head.appendChild(newLink);
      }

      // Update shortcut icon
      const shortcutLink = document.querySelector("link[rel~='shortcut icon']");
      if (shortcutLink) {
        shortcutLink.setAttribute("href", faviconPath);
      }

      // Update apple-touch-icon
      const appleLink = document.querySelector("link[rel~='apple-touch-icon']");
      if (appleLink) {
        appleLink.setAttribute("href", faviconPath);
      }
    };

    updateFavicon();
  }, [theme, systemTheme]);

  return null;
};

export default FaviconManager;
